import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.supplementCategories;
export const supplementCategoriesSelector = (state: RootState) => getState(state).data;
export const supplementCategoriesIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const supplementCategoriesIsReadySelector = (state: RootState) => getState(state).isReady;
export const supplementCategoriesErrorSelector = (state: RootState) => getState(state).error;
export const supplementCategoryByIdSelector = (categoryId?: number | null) => (state: RootState) =>
  supplementCategoriesSelector(state).find(category => category.id === categoryId);
